import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  IconButton,
  Typography,
  Avatar,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EmailIcon from "@mui/icons-material/Email";

const DepartmentTableDialog = ({
  open,
  onClose,
  selectedDepartment,
  departmentPeople,
  selectedDepartmentColor,
  onPersonClick,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle
        sx={{
          backgroundColor: selectedDepartmentColor,
          color: "#fff",
          padding: "12px 16px",
        }}
      >
        <Grid container alignItems="center" justifyContent="space-between">
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {selectedDepartment} Staff ({departmentPeople.length})
          </Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              color: "#fff",
              backgroundColor: "rgba(255,255,255,0.1)",
              "&:hover": {
                backgroundColor: "rgba(255,255,255,0.2)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Grid>
      </DialogTitle>
      <DialogContent dividers sx={{ padding: "16px" }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                <TableCell sx={{ fontWeight: "bold" }}>Name</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Staff ID</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Role</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Level</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Grade</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Country</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Contact</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {departmentPeople.map((person) => (
                <TableRow
                  key={person.id}
                  onClick={() => onPersonClick(person)}
                  sx={{
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor: "rgba(34, 139, 34, 0.05)",
                    },
                  }}
                >
                  <TableCell>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Avatar
                        src={person.profile_image}
                        alt={person.name}
                        sx={{ width: 32, height: 32, mr: 1 }}
                      >
                        {person.name ? person.name.charAt(0).toUpperCase() : "?"}
                      </Avatar>
                      {person.name}
                    </Box>
                  </TableCell>
                  <TableCell>{person.staff_id}</TableCell>
                  <TableCell>{person.role_name}</TableCell>
                  <TableCell>{person.level}</TableCell>
                  <TableCell>
                    {person.grade_id ? `Grade ${person.grade_id}` : "Unassigned"}
                  </TableCell>
                  <TableCell>{person.res_country}</TableCell>
                  <TableCell>
                    <a
                      href={`mailto:${person.per_email || person.login_id}`}
                      onClick={(e) => e.stopPropagation()}
                      style={{ color: "#228B22", textDecoration: "none" }}
                    >
                      <EmailIcon fontSize="small" />
                    </a>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {departmentPeople.length === 0 && (
          <Typography
            sx={{ textAlign: "center", p: 3, color: "text.secondary" }}
          >
            No staff found in this department
          </Typography>
        )}
      </DialogContent>
      <DialogActions sx={{ padding: "16px" }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            color: selectedDepartmentColor,
            borderColor: selectedDepartmentColor,
            "&:hover": {
              borderColor: selectedDepartmentColor.replace("1", "0.8"),
              backgroundColor: `${selectedDepartmentColor}15`,
            },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DepartmentTableDialog;
